import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import { Close, AlertWarning } from "@dfds-ui/icons"
import StyledBanner from './banner.styling'

@Component({
    selector: "sbw-banner",
    template: "<div #react></div>"
})
export class BannerComponent implements OnInit {
    hasInit = false
    @ViewChild("react", { static: true }) react: ElementRef;

    @Input() description: string;
    @Input() label: string;
    @Input() link: string;
    @Input() visible: boolean;

    @Output() bannerClosed = new EventEmitter()

    ngOnInit() {
        this.render()
    }

    render() {

        const closePopup = () => {
            this.visible = false
            this.render()
            this.bannerClosed.emit()
        }

        const replaceMarkup = () => {
            return { __html: this.description };
        }

        ReactDOM.render(
            <StyledBanner>
                {this.visible &&
                    <div className="banner-container">
                        <div className="banner-padding">
                            <div className="row">
                                <div className="column small-12 container">
                                    <div className="left">
                                        <span className="icon"><AlertWarning></AlertWarning></span>
                                        <span dangerouslySetInnerHTML={replaceMarkup()}></span>
                                    </div>
                                    <div className="right">
                                        <a className="button desktop" href={this.link}>{this.label}</a>
                                        <a className="cross" onClick={closePopup}><Close></Close></a>
                                    </div>
                                    <br className="break"></br>
                                </div>
                            </div>
                            <div className="under">
                                <a className="button mobile" href={this.link}>{this.label}</a>
                            </div>
                        </div>
                    </div>
                }
            </StyledBanner>,
            this.react.nativeElement
        );
    }
}
